/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as PublicImport } from './routes/_public'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as PublicLoginIndexImport } from './routes/_public/login/index'
import { Route as AuthenticatedRecruitPositionsIndexImport } from './routes/_authenticated/recruit-positions/index'
import { Route as PublicResetPasswordIndexImport } from './routes/_public/reset/password/index'
import { Route as PublicForgetPasswordIndexImport } from './routes/_public/forget/password/index'
import { Route as AuthenticatedRecruitPositionsRecruitPositionIdIndexImport } from './routes/_authenticated/recruit-positions/$recruitPositionId/index'
import { Route as PublicForgetPasswordResetIndexImport } from './routes/_public/forget/password/reset/index'
import { Route as PublicForgetPasswordConfirmationIndexImport } from './routes/_public/forget/password/confirmation/index'
import { Route as AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexImport } from './routes/_authenticated/recruit-positions/$recruitPositionId/recruitees/index'
import { Route as AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexImport } from './routes/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/index'

// Create/Update Routes

const PublicRoute = PublicImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const PublicLoginIndexRoute = PublicLoginIndexImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => PublicRoute,
} as any)

const AuthenticatedRecruitPositionsIndexRoute =
  AuthenticatedRecruitPositionsIndexImport.update({
    id: '/recruit-positions/',
    path: '/recruit-positions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const PublicResetPasswordIndexRoute = PublicResetPasswordIndexImport.update({
  id: '/reset/password/',
  path: '/reset/password/',
  getParentRoute: () => PublicRoute,
} as any)

const PublicForgetPasswordIndexRoute = PublicForgetPasswordIndexImport.update({
  id: '/forget/password/',
  path: '/forget/password/',
  getParentRoute: () => PublicRoute,
} as any)

const AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute =
  AuthenticatedRecruitPositionsRecruitPositionIdIndexImport.update({
    id: '/recruit-positions/$recruitPositionId/',
    path: '/recruit-positions/$recruitPositionId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const PublicForgetPasswordResetIndexRoute =
  PublicForgetPasswordResetIndexImport.update({
    id: '/forget/password/reset/',
    path: '/forget/password/reset/',
    getParentRoute: () => PublicRoute,
  } as any)

const PublicForgetPasswordConfirmationIndexRoute =
  PublicForgetPasswordConfirmationIndexImport.update({
    id: '/forget/password/confirmation/',
    path: '/forget/password/confirmation/',
    getParentRoute: () => PublicRoute,
  } as any)

const AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute =
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexImport.update({
    id: '/recruit-positions/$recruitPositionId/recruitees/',
    path: '/recruit-positions/$recruitPositionId/recruitees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute =
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexImport.update(
    {
      id: '/recruit-positions/$recruitPositionId/recruitees/$recruitee/',
      path: '/recruit-positions/$recruitPositionId/recruitees/$recruitee/',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/recruit-positions/': {
      id: '/_authenticated/recruit-positions/'
      path: '/recruit-positions'
      fullPath: '/recruit-positions'
      preLoaderRoute: typeof AuthenticatedRecruitPositionsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/login/': {
      id: '/_public/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginIndexImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/recruit-positions/$recruitPositionId/': {
      id: '/_authenticated/recruit-positions/$recruitPositionId/'
      path: '/recruit-positions/$recruitPositionId'
      fullPath: '/recruit-positions/$recruitPositionId'
      preLoaderRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/forget/password/': {
      id: '/_public/forget/password/'
      path: '/forget/password'
      fullPath: '/forget/password'
      preLoaderRoute: typeof PublicForgetPasswordIndexImport
      parentRoute: typeof PublicImport
    }
    '/_public/reset/password/': {
      id: '/_public/reset/password/'
      path: '/reset/password'
      fullPath: '/reset/password'
      preLoaderRoute: typeof PublicResetPasswordIndexImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/recruit-positions/$recruitPositionId/recruitees/': {
      id: '/_authenticated/recruit-positions/$recruitPositionId/recruitees/'
      path: '/recruit-positions/$recruitPositionId/recruitees'
      fullPath: '/recruit-positions/$recruitPositionId/recruitees'
      preLoaderRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_public/forget/password/confirmation/': {
      id: '/_public/forget/password/confirmation/'
      path: '/forget/password/confirmation'
      fullPath: '/forget/password/confirmation'
      preLoaderRoute: typeof PublicForgetPasswordConfirmationIndexImport
      parentRoute: typeof PublicImport
    }
    '/_public/forget/password/reset/': {
      id: '/_public/forget/password/reset/'
      path: '/forget/password/reset'
      fullPath: '/forget/password/reset'
      preLoaderRoute: typeof PublicForgetPasswordResetIndexImport
      parentRoute: typeof PublicImport
    }
    '/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/': {
      id: '/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/'
      path: '/recruit-positions/$recruitPositionId/recruitees/$recruitee'
      fullPath: '/recruit-positions/$recruitPositionId/recruitees/$recruitee'
      preLoaderRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexImport
      parentRoute: typeof AuthenticatedImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedRecruitPositionsIndexRoute: typeof AuthenticatedRecruitPositionsIndexRoute
  AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute: typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedRecruitPositionsIndexRoute:
    AuthenticatedRecruitPositionsIndexRoute,
  AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute:
    AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute,
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute:
    AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute,
  AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute:
    AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginIndexRoute: typeof PublicLoginIndexRoute
  PublicForgetPasswordIndexRoute: typeof PublicForgetPasswordIndexRoute
  PublicResetPasswordIndexRoute: typeof PublicResetPasswordIndexRoute
  PublicForgetPasswordConfirmationIndexRoute: typeof PublicForgetPasswordConfirmationIndexRoute
  PublicForgetPasswordResetIndexRoute: typeof PublicForgetPasswordResetIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginIndexRoute: PublicLoginIndexRoute,
  PublicForgetPasswordIndexRoute: PublicForgetPasswordIndexRoute,
  PublicResetPasswordIndexRoute: PublicResetPasswordIndexRoute,
  PublicForgetPasswordConfirmationIndexRoute:
    PublicForgetPasswordConfirmationIndexRoute,
  PublicForgetPasswordResetIndexRoute: PublicForgetPasswordResetIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof PublicRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/recruit-positions': typeof AuthenticatedRecruitPositionsIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/recruit-positions/$recruitPositionId': typeof AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute
  '/forget/password': typeof PublicForgetPasswordIndexRoute
  '/reset/password': typeof PublicResetPasswordIndexRoute
  '/recruit-positions/$recruitPositionId/recruitees': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute
  '/forget/password/confirmation': typeof PublicForgetPasswordConfirmationIndexRoute
  '/forget/password/reset': typeof PublicForgetPasswordResetIndexRoute
  '/recruit-positions/$recruitPositionId/recruitees/$recruitee': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute
}

export interface FileRoutesByTo {
  '': typeof PublicRouteWithChildren
  '/': typeof AuthenticatedIndexRoute
  '/recruit-positions': typeof AuthenticatedRecruitPositionsIndexRoute
  '/login': typeof PublicLoginIndexRoute
  '/recruit-positions/$recruitPositionId': typeof AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute
  '/forget/password': typeof PublicForgetPasswordIndexRoute
  '/reset/password': typeof PublicResetPasswordIndexRoute
  '/recruit-positions/$recruitPositionId/recruitees': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute
  '/forget/password/confirmation': typeof PublicForgetPasswordConfirmationIndexRoute
  '/forget/password/reset': typeof PublicForgetPasswordResetIndexRoute
  '/recruit-positions/$recruitPositionId/recruitees/$recruitee': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/recruit-positions/': typeof AuthenticatedRecruitPositionsIndexRoute
  '/_public/login/': typeof PublicLoginIndexRoute
  '/_authenticated/recruit-positions/$recruitPositionId/': typeof AuthenticatedRecruitPositionsRecruitPositionIdIndexRoute
  '/_public/forget/password/': typeof PublicForgetPasswordIndexRoute
  '/_public/reset/password/': typeof PublicResetPasswordIndexRoute
  '/_authenticated/recruit-positions/$recruitPositionId/recruitees/': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesIndexRoute
  '/_public/forget/password/confirmation/': typeof PublicForgetPasswordConfirmationIndexRoute
  '/_public/forget/password/reset/': typeof PublicForgetPasswordResetIndexRoute
  '/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/': typeof AuthenticatedRecruitPositionsRecruitPositionIdRecruiteesRecruiteeIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/'
    | '/recruit-positions'
    | '/login'
    | '/recruit-positions/$recruitPositionId'
    | '/forget/password'
    | '/reset/password'
    | '/recruit-positions/$recruitPositionId/recruitees'
    | '/forget/password/confirmation'
    | '/forget/password/reset'
    | '/recruit-positions/$recruitPositionId/recruitees/$recruitee'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/'
    | '/recruit-positions'
    | '/login'
    | '/recruit-positions/$recruitPositionId'
    | '/forget/password'
    | '/reset/password'
    | '/recruit-positions/$recruitPositionId/recruitees'
    | '/forget/password/confirmation'
    | '/forget/password/reset'
    | '/recruit-positions/$recruitPositionId/recruitees/$recruitee'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/'
    | '/_authenticated/recruit-positions/'
    | '/_public/login/'
    | '/_authenticated/recruit-positions/$recruitPositionId/'
    | '/_public/forget/password/'
    | '/_public/reset/password/'
    | '/_authenticated/recruit-positions/$recruitPositionId/recruitees/'
    | '/_public/forget/password/confirmation/'
    | '/_public/forget/password/reset/'
    | '/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/_public"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/",
        "/_authenticated/recruit-positions/",
        "/_authenticated/recruit-positions/$recruitPositionId/",
        "/_authenticated/recruit-positions/$recruitPositionId/recruitees/",
        "/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/"
      ]
    },
    "/_public": {
      "filePath": "_public.tsx",
      "children": [
        "/_public/login/",
        "/_public/forget/password/",
        "/_public/reset/password/",
        "/_public/forget/password/confirmation/",
        "/_public/forget/password/reset/"
      ]
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/recruit-positions/": {
      "filePath": "_authenticated/recruit-positions/index.tsx",
      "parent": "/_authenticated"
    },
    "/_public/login/": {
      "filePath": "_public/login/index.tsx",
      "parent": "/_public"
    },
    "/_authenticated/recruit-positions/$recruitPositionId/": {
      "filePath": "_authenticated/recruit-positions/$recruitPositionId/index.tsx",
      "parent": "/_authenticated"
    },
    "/_public/forget/password/": {
      "filePath": "_public/forget/password/index.tsx",
      "parent": "/_public"
    },
    "/_public/reset/password/": {
      "filePath": "_public/reset/password/index.tsx",
      "parent": "/_public"
    },
    "/_authenticated/recruit-positions/$recruitPositionId/recruitees/": {
      "filePath": "_authenticated/recruit-positions/$recruitPositionId/recruitees/index.tsx",
      "parent": "/_authenticated"
    },
    "/_public/forget/password/confirmation/": {
      "filePath": "_public/forget/password/confirmation/index.tsx",
      "parent": "/_public"
    },
    "/_public/forget/password/reset/": {
      "filePath": "_public/forget/password/reset/index.tsx",
      "parent": "/_public"
    },
    "/_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/": {
      "filePath": "_authenticated/recruit-positions/$recruitPositionId/recruitees/$recruitee/index.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
